<template lang="pug">
  include ./../../vuek/mixins.pug

  +b.the-neighbors-section
    t-section
      template(v-if="lng === 'ua'")
        //- t-h2 Індекс сприйняття корупції-2018. Порівняння України та сусідів
        +e.IMG.img(src="static/img/info_ua.png")

      template(v-if="lng === 'en'")
        //- t-h2 CPI 2018. Ukraine vs. Its Neighbors
        +e.IMG.img(src="static/img/info_en.png")
</template>

<script>
import { mapGetters } from 'vuex';

import TSection from '@/components/TSection/TSection';
import TH2 from '@/components/TH2/TH2';
import TH3 from '@/components/TH3/TH3';

export default {
  name: 'the-neighbors-section',

  computed: {
    ...mapGetters({
      lng: 'lng',
    }),
  },

  components: {
    TSection,
    TH2,
    TH3,
  },
};
</script>

<style lang="scss">
@import '../../scss/styles';

.the-neighbors-section {
  &__text {
    color: #000;
    font-weight: 100;
    text-align: left;
    font-size: 14px;
  }

  &__img {
    width: 100%;
    margin-top: 64px;
    // height: 320px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/TheNeighborsSection/TheNeighborsSection.vue